import React, {useMemo} from 'react';
import {createPlayPresentationUrl} from '../../../../../utils/presentation';
import {IPresentationMeta} from '../../../../../incase-domain/presentation';
import PresentationLink from './PresentationLink';

interface IPresenterLinkProps {
    presentation: IPresentationMeta;
    roomId?: string;
    presenterLinkCode?: string;
}

function PresenterLink({presentation, roomId, presenterLinkCode}: IPresenterLinkProps): JSX.Element {
    const presenterLink = useMemo(() => {
        return createPlayPresentationUrl(presentation, false, roomId, !!roomId, undefined, presenterLinkCode);
    }, [presentation, roomId, presenterLinkCode]);

    return <PresentationLink link={presenterLink} />;
}

export default PresenterLink;
